<template>
  <ToastMessage
    v-if="props.message"
    :variant="resolvedVariant"
    :message="resolvedMessage"
    :duration="resolvedDuration"
    @dismiss="handleDismiss"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { ToastMessage } from '@p-utilities/vue'
import { useSnackbarStore } from '@/store/snackbar'

const { t } = useI18n()
const snackbarStore = useSnackbarStore()

const emit = defineEmits(['on-next'])

interface SnackbarMessage {
  severity?: 'info' | 'success' | 'danger'
  title?: { langkey: string; params?: Record<string, unknown> }
  link?: {
    url: string
    target?: string
    label?: { langkey: string; params?: Record<string, unknown> }
  }
  timeout?: number
  persistent?: boolean
}

const props = defineProps<{
  message: SnackbarMessage
}>()

// DS ToastMessage only exposes 'success' | 'danger' variants — no 'info'.
// 'info' severity from the local snackbar shape collapses to 'success' as a
// visual fallback. If a distinct info style is needed later, extend DS.
const resolvedVariant = computed<'success' | 'danger'>(() => {
  return props.message.severity === 'danger' ? 'danger' : 'success'
})

const resolvedMessage = computed(() => {
  const title = props.message.title
  if (!title?.langkey) return ''
  return t(title.langkey, title.params ?? {})
})

const resolvedDuration = computed(() => {
  if (props.message.persistent) return 0
  return props.message.timeout ?? 3000
})

const handleDismiss = () => {
  snackbarStore.deleteSnackbar()
  emit('on-next')
}
</script>
